export const formatPartLabel = ({
  partNumber,
  revision,
}: {
  partNumber: string;
  revision?: string | null;
}): string => `${partNumber || '--'}${revision ? ` REV ${revision}` : ''}`;

export const formatPartLabelOrFilename = ({
  partNumber,
  revision,
  filename,
}: {
  partNumber: string;
  revision?: string | null;
  filename: string;
}): string =>
  partNumber
    ? `#${partNumber}${revision ? ` REV ${revision}` : ''}`
    : filename || '--';
